import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import { useAuthStore } from '../../stores/useAuthStore';
import LoadingSpinner from '../layout/LoadingSpinner';

export default function PrivateRoute() {
  const [authState, setAuthState] = useState('loading');
  const setAuth = useAuthStore((s) => s.setAuth);
  const clearAuth = useAuthStore((s) => s.clearAuth);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const user = await getCurrentUser();
        let attrs = {};
        try { attrs = await fetchUserAttributes(); } catch { /* attrs are best-effort */ }
        if (!cancelled) {
          setAuth({
            userId: user.userId,
            username: user.username,
            email: attrs.preferred_username || attrs.email || user.signInDetails?.loginId,
            name: attrs.name || '',
            preferredUsername: attrs.preferred_username || '',
          });
          setAuthState('authenticated');
        }
      } catch {
        if (!cancelled) {
          clearAuth();
          setAuthState('unauthenticated');
        }
      }
    })();
    return () => { cancelled = true; };
  }, [setAuth, clearAuth]);

  if (authState === 'loading') return <LoadingSpinner />;
  if (authState === 'unauthenticated') return <Navigate to="/login" replace />;
  return <Outlet />;
}
